var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgObligationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 0H6C2.7 0 0 3 0 6.66667V53.3333C0 57 2.7 60 6 60H54C57.3 60 60 57 60 53.3333V6.66667C60 3 57.3 0 54 0ZM6 53.3333V6.66667H54V16.6667H36C32.7 16.6667 30 19.6667 30 23.3333V36.6667C30 40.3333 32.7 43.3333 36 43.3333H54V53.3333H6ZM54 23.3333V36.6667H36V23.3333H54Z",
    fill: "#077CA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObligationIcon);
export default __webpack_public_path__ + "static/media/ObligationIcon.a7e6e46c966d9f916fed76a3b7424b11.svg";
export { ForwardRef as ReactComponent };